// extracted by mini-css-extract-plugin
export default {"priceDisplay":"PriceDisplay_priceDisplay__ABJok","headline":"PriceDisplay_headline__5D1GC","period":"PriceDisplay_period__7vEV2","description":"PriceDisplay_description__YHj+g"};